export function sanitize<T = any>(data: T): T {
	for (const key in data) {
		if (typeof data[key] === undefined || data[key] === undefined) {
			delete data[key];
		}
	}
	return data;
}
